export default __webpack_public_path__ + "static/media/download-dark.f675be2c.svg";